import {FormEvent, useState} from "react";
import {Card, Form, InputGroup, Table} from "react-bootstrap";
import {Link} from "react-router";
import {DocumentationApi} from "../../api/DocumentationApi";
import {DocumentationDownloadViewModel} from "../../api/models";
import {ErrorAlert} from "../../components/ErrorAlert";
import {PageHeader} from "../../components/PageHeader";
import {SubmitButton} from "../../components/SubmitButton";
import {formatDateTime} from "../../components/format";

// Traces a documentation PDF back to who it was made for, from the download ID printed on its pages.
export function DocumentationDownloadsPage() {
    const [downloadId, setDownloadId] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<unknown>();
    const [found, setFound] = useState<DocumentationDownloadViewModel>();

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        if (!downloadId.trim()) {
            return;
        }
        setBusy(true);
        setError(undefined);
        setFound(undefined);
        try {
            setFound(await DocumentationApi.findDownload(downloadId));
        } catch (err) {
            setError(err);
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <PageHeader title="Documentation downloads"/>
            <p className="text-body-secondary">
                Every documentation PDF shows a download ID (DOC-XXXX-XXXX) in its footer, across its pages and in its document
                properties. Enter one to find out who the PDF was made for.
            </p>
            <Form onSubmit={submit} className="mb-4 docs-download-form">
                <Form.Label htmlFor="download-id">Download ID</Form.Label>
                <InputGroup>
                    <Form.Control id="download-id" className="license-key" placeholder="DOC-XXXX-XXXX" value={downloadId}
                                  onChange={e => setDownloadId(e.target.value)} autoComplete="off" spellCheck={false}/>
                    <SubmitButton busy={busy}>Look up</SubmitButton>
                </InputGroup>
            </Form>
            <ErrorAlert error={error} messages={{ 404: 'No PDF has that download ID. Check it was typed correctly.' }}/>
            {found && (
                <Card>
                    <Card.Header className="license-key">{found.id}</Card.Header>
                    <Table className="mb-0">
                        <tbody>
                        <tr><th scope="row">User</th><td>
                            {found.displayName ? <>{found.displayName} ({found.username})</> : <>{found.username} <span className="text-body-secondary">(account deleted)</span></>}
                        </td></tr>
                        {found.emailAddress && <tr><th scope="row">Email address</th><td>{found.emailAddress}</td></tr>}
                        <tr><th scope="row">Product</th><td>
                            {found.productName ? <Link to={`/admin/products/${encodeURIComponent(found.productId)}`}>{found.productName}</Link> : found.productId}
                        </td></tr>
                        <tr><th scope="row">Documentation version</th><td>{found.docVersion}</td></tr>
                        <tr><th scope="row">Generated</th><td>{formatDateTime(found.createdOn)}</td></tr>
                        <tr><th scope="row">IP address</th><td>{found.ip}</td></tr>
                        </tbody>
                    </Table>
                </Card>
            )}
        </>
    );
}
